// extracted by mini-css-extract-plugin
export default {"fpContent":"flow-page_fpContent__YUFkB","fpToolbar":"flow-page_fpToolbar__bt-8v"};